var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('page-header',{attrs:{"id":"header","headers":{
      daynight: _vm.daynight,
      portrait: _vm.portrait,
      updatetime: _vm.updatetime,
      location: _vm.location,
      username: _vm.username
    }}}),_vm._v(" "),_c('transition',{attrs:{"duration":2000,"enter-active-class":"animated bounceInRight","leave-active-class":"animated bounceOutLeft"}},[_c('keep-alive',[_c('router-view',{staticClass:"child-box",attrs:{"current":_vm.current}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7079a1de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 